export const storage = {
  /**
   * 저장
   */
  set(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
  },

  /**
   * 조회
   */
  get(key: string) {
    const value = localStorage.getItem(key);

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  },

  /**
   * 삭제
   */
  remove(key: string) {
    localStorage.removeItem(key);
  },

  /**
   * 전체 삭제
   */
  clear() {
    localStorage.clear();
  },
};
